import { IPriceSnapshotState } from '@/store/pricesnapshot';
import { IPriceSnapshotGetters } from './getters.types';
import { IPriceSnapshot, PriceSnapshot } from '@/models';

export const getters: IPriceSnapshotGetters = {
  getPriceSnapshots(state: IPriceSnapshotState): IPriceSnapshot[] {
    return state.priceSnapshots.map(data => new PriceSnapshot(data));
  },

  getPriceSnapshotById: (state: IPriceSnapshotState) => (
    pricesnapshotId: number
  ): IPriceSnapshot | undefined => {
    const data = state.priceSnapshots.find(({ id }) => id === pricesnapshotId);
    if (!data) {
      return undefined;
    }

    return new PriceSnapshot(data);
  },

  getPriceSnapshotCount(state: IPriceSnapshotState): number {
    return state.count;
  }
};
